<script>
export default {
  name: "PrivacyPolicy",
  mounted() {
    document.documentElement.style.overflow = "unset";
    setTimeout(() => {
      window.scrollTo(0, 0);
    });
  },
};
</script>

<template>
  <div>
    <h1 class="mb-5 text-3xl font-bold">{{ $t("title.privacyPolicy") }}</h1>
  </div>
</template>
